import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'
import { ITrack } from '../Interface/track'

@Injectable({
  providedIn: 'root'
})
export class ShareTrackPopupService {
  isShareTrackPopupOpenSubject: Subject<ITrack> = new Subject<ITrack>()

  open(track: ITrack) {
    this.isShareTrackPopupOpenSubject.next(track)
  }
}
